// src/features/checkIns/components/OverallSummary.jsx
import React from 'react';
import './checkInComponents.css';

const RATING_OPTIONS = ['Outstanding', 'Exceeds Expectations', 'Meets Expectations', 'Needs Improvement', 'Unsatisfactory'];

const OverallSummary = ({ overall, onChange, isReadOnly, isManagerView }) => {
  const data = overall || {};
  const employeeLocked = isReadOnly || isManagerView;

  return (
    <div>
      <h3 className="cc-summary-title">Overall Summary</h3>

      <div className="cc-field">
        <label className="cc-label">Overall Rating</label>
        <select
          className="cc-select"
          value={data.rating || ''}
          disabled={employeeLocked}
          onChange={(e) => onChange('rating', e.target.value)}
        >
          <option value="">Select Rating</option>
          {RATING_OPTIONS.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>

      <div className="cc-field">
        <label className="cc-label">Key Achievements</label>
        <textarea
          className="cc-textarea"
          placeholder="List your key achievements this period..."
          value={data.achievements || ''}                     
          disabled={employeeLocked}
          onChange={(e) => onChange('achievements', e.target.value)}  
        />
      </div>

      <div className="cc-field">
        <label className="cc-label">Challenges Faced</label>
        <textarea
          className="cc-textarea"
          placeholder="Describe challenges you encountered..."
          value={data.challenges || ''}
          disabled={employeeLocked}
          onChange={(e) => onChange('challenges', e.target.value)}
        />
      </div>

      <div className="cc-field">
        <label className="cc-label">Summary Notes</label>
        <textarea
          className="cc-textarea"
          placeholder="Overall summary of your performance..."
          value={data.summaryNotes || ''}
          disabled={employeeLocked}
          onChange={(e) => onChange('summaryNotes', e.target.value)}
        />
      </div>

      <div className="cc-field" style={{ marginBottom: 0 }}>
        <label className="cc-label">Recommendations</label>
        <textarea
          className="cc-textarea"
          placeholder="Recommendations for next period..."
          value={data.recommendations || ''}
          disabled={employeeLocked}
          onChange={(e) => onChange('recommendations', e.target.value)}
        />
      </div>
    </div>
  );
};

export default OverallSummary;